module.exports = __webpack_public_path__ + "img/logo.8343af4.svg";